function styleInject(css, ref) {
  if (ref === void 0) {
    ref = {};
  }
  const insertAt = ref.insertAt;
  if (typeof document === "undefined") {
    return;
  }
  const head = document.head || document.getElementsByTagName("head")[0];
  const style = document.createElement("style");
  style.type = "text/css";
  if (insertAt === "top") {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  const { styleSheet } = style;
  if (styleSheet) {
    styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
styleInject(`.avia-replay{background:#000;height:100%;left:0;position:absolute;top:0;width:100%;z-index:2}.avia-replay-circle{align-items:center;background-color:hsla(0,0%,39%,.5);border-radius:50%;-webkit-box-sizing:border-box;box-sizing:border-box;color:#fff;display:flex;height:66px;justify-content:center;left:50%;margin-left:-33px;margin-top:-33px;padding:0;position:absolute;top:50%;width:66px;z-index:10000}.avia-replay-icon{background-color:transparent;background-image:url('data:image/svg+xml;charset=utf-8,<svg fill="%23fff" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M437.09 74.98C388.78 26.63 324.55 0 256.234 0 194.656 0 136.07 21.809 89.707 61.7L40.105 12.96 30.168 181.47l171.3-12.668-48.609-45.028c29.422-23.101 65.57-35.668 103.375-35.668 92.493 0 167.743 75.317 167.743 167.895s-75.25 167.898-167.743 167.898c-42.464 0-82.976-15.918-114.078-44.816-30.933-28.75-49.797-67.687-53.11-109.644l-1.093-13.817H0l.95 15.895C9.015 406.367 121.147 512 256.233 512c68.317 0 132.547-26.629 180.856-74.98C485.395 388.668 512 324.379 512 256s-26.605-132.668-74.91-181.02zm0 0"/></svg>');background-position:50%;background-repeat:no-repeat;background-size:60% 60%;border:none;border-radius:none;cursor:pointer;font-size:inherit;height:100px;line-height:inherit;margin:0;outline:0;padding:0;text-align:center;width:100px}`);
const REPLAY = "replay";
function replay(options = {}) {
  return {
    id: REPLAY,
    factory: createReplayPlugin,
    options
  };
}
function createReplayPlugin(services, options) {
  return new AviaReplayPlugin(services, options);
}
class AviaReplayPlugin {
  constructor(services, options) {
    this.listening = false;
    const { avia, player, dom } = services;
    const { PlayerEvent } = avia;
    this.options = options;
    this.avia = avia;
    this.player = player;
    this.container = dom.main;
    this.onContentStart = this.onContentStart.bind(this);
    this.onEnded = this.onEnded.bind(this);
    player.on(PlayerEvent.CONTENT_START, this.onContentStart);
    player.once(PlayerEvent.CONTENT_PROGRESS, this.onContentStart);
    player.on(PlayerEvent.LIVE_PRESENTATION_STOPPED, this.onEnded);
  }
  getId() {
    return REPLAY;
  }
  destroy() {
    const { panel, player } = this;
    const { PlayerEvent } = this.avia;
    if (panel) {
      panel.onclick = null;
      this.container.removeChild(panel);
      this.panel = null;
    }
    player.off(PlayerEvent.CONTENT_START, this.onContentStart);
    player.off(PlayerEvent.CONTENT_PROGRESS, this.onContentStart);
    player.off(PlayerEvent.LIVE_PRESENTATION_STOPPED, this.onEnded);
    const playlistPlugin = player.getPlugin("playlist");
    if (playlistPlugin) {
      player.off(PlayerEvent.PLUGIN_EVENT, this.onEnded);
    } else {
      player.off(PlayerEvent.RESOURCE_END, this.onEnded);
    }
    this.listening = false;
    this.resource = null;
    this.player = null;
    this.avia = null;
    this.options = null;
    this.container = null;
  }
  onContentStart() {
    const { player } = this;
    if (this.listening) {
      return;
    }
    this.resource = player.resource;
    const playlistPlugin = player.getPlugin("playlist");
    if (playlistPlugin) {
      player.on(this.avia.PlayerEvent.PLUGIN_EVENT, this.onEnded);
    } else {
      player.on(this.avia.PlayerEvent.RESOURCE_END, this.onEnded);
    }
    this.listening = true;
  }
  onEnded(event) {
    var _a;
    if (!this.resource) {
      return;
    }
    if (event.type === this.avia.PlayerEvent.PLUGIN_EVENT && ((_a = event.detail) == null ? void 0 : _a.type) !== "playlistcomplete") {
      return;
    }
    this.render();
  }
  render() {
    const { player, container, resource } = this;
    const panel = document.createElement("div");
    panel.classList.add("avia-replay");
    panel.style.zIndex = (this.options.level || 100).toString();
    panel.innerHTML = '<div class="avia-replay-circle"><button class="avia-replay-icon"></button></div>';
    panel.onclick = () => {
      resource.playback.startTime = 0;
      player.attachResource(resource);
      container.removeChild(panel);
    };
    container.appendChild(panel);
    this.panel = panel;
  }
}
const ID = REPLAY;
const createPlugin = createReplayPlugin;
const plugin = replay;
export {
  AviaReplayPlugin,
  ID,
  REPLAY,
  createPlugin,
  createReplayPlugin,
  plugin,
  replay
};
//# sourceMappingURL=avia.replay.esm.js.map
